const galleonPreview = props => {
    const {previewTitle, previewSubtitle, src} = props;
    return (
        <div
            id="preview-modal"
            className="modal hide preview preview-photobook in"
            style={{display: "block"}}
        >
            <div className="modal-header desktop-only">
                <div>
                    {" "}
                    {/** TODO: check removing it */}
                    <div className="preview-title">
                        <div className="preview-description">
                            <div>{previewTitle}</div>
                            <div className="preview-subtitle">
                                {'"' + previewSubtitle + '"'}
                            </div>
                        </div>
                        <div className="preview-imageIndex"/>
                    </div>
                </div>
            </div>
            <div className="modal-body">
                <div>
                    <div
                        className="row close-button mobile-only"
                        style={{float: "right"}}
                    >
                        <button
                            type="button"
                            className="button primary-button"
                            onClick={props.closeModal}
                        >
                            close
                        </button>
                    </div>
                    <iframe
                        id="bookPreview"
                        src={src}
                        scrolling="no"
                        style={{
                            display: "block",
                            position: "relative",
                            width: "100%",
                            height: "100%",
                            top: 0,
                            overflow: "hidden",
                            border: "1px solid #BBBBBB"
                        }}
                        webkitAllowFullScreen
                        mozallowfullscreen
                        allowFullScreen
                    />
                </div>
            </div>
            <div className="modal-footer desktop-only">
                <div className="modal-footer-actions">
                    <ul className="list-inline list-inline-piped list-inline-right modal-action">
                        {/*<li>
                        <a className="tertiary-link" data-action="edit" href={props.redirectURL + "&amp;fromCart=false"}>
                            Edit
                                </a>
                    </li>*/}
                    </ul>
                    <button
                        className="modal-action button primary-button"
                        onClick={props.closeModal}
                    >
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
};

export default galleonPreview;
